import Cookies from "js-cookie";

export async function addBasketItem(product, quantity, price, euroPrice) { 
  const newItem = {
    id: product.id,
    variantId : product.variantProductId,
    fullName: product.fullName,
    urlImage: product.urlImage,
    currency: product.currency,
    snRequired: product.requireOther,
    phoneRequired: product.requirePhone,
    quantity,
    price,
    euroPrice
  };
  let basket = await getBasketItems();
  const findProductById = (element) => element.id === product.id && element.price == price; 
  const productIndx = basket.findIndex(findProductById);
  if (productIndx === -1) basket.push(newItem);
  else {
    basket[productIndx].quantity += newItem.quantity;
    basket[productIndx].total = basket[productIndx].price * basket[productIndx].quantity + basket[productIndx].price*basket[productIndx].quantity*0.03
  }; 
  await Cookies.set("giftSwapCart", JSON.stringify(basket), { expires: 7 });
  return basket;
}

export async function getBasketItems() {
  let cart = await Cookies.get("giftSwapCart"); 
  if (!cart) return [];
  else return JSON.parse(cart);
}

export async function deleteBasketItem(productId) {
  let basket = await getBasketItems(); 
  const findProductById = (element) => element.id === productId;
  const productIndx = basket.findIndex(findProductById);

  if (productIndx !== -1) basket.splice(productIndx, 1);

  await Cookies.set("giftSwapCart", JSON.stringify(basket), { expires: 7 });
  return basket;
}

export async function updateItemQty(productId, quantity) {
  let basket = await getBasketItems();  
  const findProductById = (element) => element.id === productId;
  const productIndx = basket.findIndex(findProductById);

  basket[productIndx].quantity = quantity
  basket[productIndx].total = basket[productIndx].price * basket[productIndx].quantity + basket[productIndx].price*basket[productIndx].quantity*0.03

  await Cookies.set("giftSwapCart", JSON.stringify(basket), { expires: 7 });
  return basket;
}

export async function emptyBasket() {
  await Cookies.remove("giftSwapCart");
  return [];
}
